import React from 'react'
import { makeStyles } from '@material-ui/core'
import CardValores from './CardValores'
import { COLORES } from '../../../../config/colores'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import ReceiptIcon from '@material-ui/icons/Receipt'
import DonutLargeIcon from '@material-ui/icons/DonutLarge'
import TimelineIcon from '@material-ui/icons/Timeline'

const useStyles = makeStyles((theme) => ({
  constainer: {
    border: '2px solid',
    borderRadius: '18px',
    borderColor: 'white',
    height: '100%'
  },
  instancias: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '1px',
    flexWrap: 'wrap'
  },
  instancia: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#6022610f',
    borderRadius: '22px',
    padding: '22px',
    // Estado inicial
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    transform: 'scale(1)',
    boxShadow: theme.shadows[2],
    // Estado hover
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[10]
    }
  },
  circle: {
    padding: '28px',
    borderRadius: '800px',
    backgroundColor: '#ffffff33',
    color: COLORES.grey.dark,
    width: '80px',
    height: '80px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '2.8rem',
    fontWeight: 'bold'
  },
  cantidad: {
    textAlign: 'center',
    marginTop: '15%',
    fontWeight: '600'

  },
  titulo: {
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: '600'
  },
  icon: {
    margin: 'auto',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fontSize: '2rem'
    }
  }
}))

const ICONOS = {
  'Sin calar': <DonutLargeIcon />,
  Calados: <AssignmentTurnedInIcon />,
  'Con peso bruto': <LocalShippingIcon />,
  Descargados: <ReceiptIcon />
}

export default function ValoresCircuito (props) {
  const { circuito } = props
  const classes = useStyles()

  // Icono por defecto
  const defaultIcon = () => <LocalShippingIcon />

  const renderInstancia = () => {
    return (
      <div className={classes.instancias} >
        {(circuito && circuito.length > 0) && circuito.map((i) => {
          const IconComponent = ICONOS[i.titulo] || defaultIcon
          return (
            <div key={i} className={classes.instancia}>

              <div className={classes.circle}>
                <div className={classes.icon}>{IconComponent}</div>
              </div>
              <h1 className={classes.cantidad}> {i.cantidad} </h1>
              <h6 className={classes.titulo}> {i.titulo} </h6>
            </div>
          )
        })
        }

      </div>
    )
  }

  return (
    <div className={classes.container}>
      <CardValores
        titulo='Circuito de descarga'
        contenido={renderInstancia()}
        icono={<TimelineIcon />}
        cardColor={'#6ba5cf'}
      />
    </div>
  )
}
